var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-381d9025"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "flex absolute top-0 z-[9]" };
const _hoisted_4 = {
    key: 0,
    class: "mt-2 ml-2"
};
const _hoisted_5 = {
    key: 0,
    class: "m-2"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 1,
    class: "m-2"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
    key: 2,
    class: /*#__PURE__*/ _normalizeClass(['absolute w-full inset-0'])
};
const _hoisted_12 = { class: "file-name text-xs truncate font-bold text-white absolute bottom-4 left-2" };
const _hoisted_13 = { class: "font-bold hover-name" };
import MediaServices from '@/services/MediaService';
import { CheckCircleIcon, DotsVerticalIcon, Download01Icon, DownloadCloud02Icon, FolderIcon, Link02Icon, TextInputIcon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIButton, UICheckbox, UIDropdown, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import { GOOGLE_DRIVE, PRIVATE_SYSTEM_FOLDER, SYSTEM_FOLDER, } from 'src/util/const_helper';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { truncate } from 'lodash';
import { computed, h, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import FailedWithTextIcon from '../assets/img/failed-expanded.svg';
import FailedIcon from '../assets/img/failed.svg';
import ProcessingWithTextIcon from '../assets/img/processing-expanded.svg';
import ProcessingIcon from '../assets/img/processing.svg';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import config from '../config';
import { useStore } from '../store';
import { MIME_TYPES } from '../util/const_helper';
import { PRIVATE } from 'src/helper/const';
import AudioPrivateIcon from '../assets/img/audio-lock.svg';
import CsvPrivateIcon from '../assets/img/csv-lock.svg';
import DocsPrivateIcon from '../assets/img/docs-lock.svg';
import PptPrivateIcon from '../assets/img/ppt-lock.svg';
import ExcelPrivateIcon from '../assets/img/excel-lock.svg';
import VideoPrivateIcon from '../assets/img/video-lock.svg';
import VideoEncodedPrivateIcon from '../assets/img/video-encoded-lock.svg';
import TextPrivateIcon from '../assets/img/txt-lock.svg';
import PdfPrivateIcon from '../assets/img/pdf-lock.svg';
import ZipPrivateIcon from '../assets/img/zip-lock.svg';
import ImagePrivateIcon from '../assets/img/image-lock.svg';
import TtfIcon from '../assets/img/ttf.svg';
import OtfIcon from '../assets/img/otf.svg';
import WoffIcon from '../assets/img/woff.svg';
import Woff2Icon from '../assets/img/woff2.svg';
import AudioIcon from '../assets/img/audio-2.svg';
import CsvIcon from '../assets/img/csv.svg';
import DocsIcon from '../assets/img/docs-2.svg';
import PptIcon from '../assets/img/ppt.svg';
import ExcelIcon from '../assets/img/excel-2.svg';
import VideoEncodedIcon from '../assets/img/video-encoded.svg';
import VideoIcon from '../assets/img/video.svg';
import TextIcon from '../assets/img/text-2.svg';
import PdfIcon from '../assets/img/pdf-2.svg';
import ZipIcon from '../assets/img/zip.svg';
import TtfPrivateIcon from '../assets/img/ttf-lock.svg';
import OtfPrivateIcon from '../assets/img/otf-lock.svg';
import WoffPrivateIcon from '../assets/img/woff-lock.svg';
import Woff2PrivateIcon from '../assets/img/woff2-lock.svg';
import { copyToClipboard, copyPrivateUrl, downloadFile, formatBytes, getDownloadUrl, getFileExtension, } from '../util/helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileItem',
    props: {
        file: {},
        activeItem: {},
        disabled: { type: Boolean }
    },
    emits: ["onClickImage"],
    setup(__props, { emit: __emit }) {
        const emitter = useEmitter();
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        dayjs.extend(relativeTime);
        const props = __props;
        const emit = __emit;
        const state = useStore();
        function timeFromNow(date) {
            return dayjs(date).fromNow();
        }
        const selfHosted = computed(() => {
            return state.selfHosted;
        });
        const isSelected = computed(() => {
            return Boolean(state.selectedItems.find(item => item._id === props.file._id));
        });
        const contextMenuItems = computed(() => {
            const items = [
                {
                    icon() {
                        return h(renderIcon(CheckCircleIcon), null, {});
                    },
                    label: t('common.select'),
                    key: 'select',
                },
                {
                    icon() {
                        return h(renderIcon(Link02Icon), null, {});
                    },
                    label: props.file.isPrivate
                        ? t('common.getPrivateLink')
                        : t('common.getLink'),
                    key: 'copy',
                    disabled: state.activeCategory.includes(GOOGLE_DRIVE),
                },
                {
                    icon() {
                        return h(renderIcon(FolderIcon), null, {});
                    },
                    label: t('common.moveToFolder'),
                    key: 'move',
                    disabled: state.activeCategory.includes(GOOGLE_DRIVE) ||
                        props.file.isPrivate ||
                        Object.keys(SYSTEM_FOLDER).includes(props.file.category),
                },
                {
                    icon() {
                        return h(renderIcon(TextInputIcon), null, {});
                    },
                    label: t('common.rename'),
                    key: 'rename',
                    disabled: state.activeCategory.includes(GOOGLE_DRIVE) ||
                        props.file.isPrivate ||
                        Object.keys(SYSTEM_FOLDER).includes(props.file.category),
                },
                {
                    icon() {
                        return h(renderIcon(Trash01Icon), null, {});
                    },
                    label: t('common.delete'),
                    key: 'delete',
                    disabled: state.activeCategory.includes(GOOGLE_DRIVE),
                },
            ];
            if (state.activeCategory.includes(GOOGLE_DRIVE))
                items.push({
                    icon() {
                        return h(renderIcon(DownloadCloud02Icon), null, {});
                    },
                    label: t('common.importToMediaLibrary'),
                    key: 'import',
                });
            return items;
        });
        const hover = ref(false);
        const hoverDropdown = ref(false);
        const statusHover = ref(false);
        const dropdownOutsideClickRef = ref();
        const getImageServerUrl = (image) => {
            var _a;
            try {
                const url = new URL(image);
                if ((_a = config.imageServerWhitelist) === null || _a === void 0 ? void 0 : _a.includes(url.hostname))
                    return `${config.imageServer}/image/f_webp/q_80/r_320/u_${image}`;
                else
                    return image;
            }
            catch (error) {
                console.error(error);
                return image;
            }
        };
        const isEncoded = computed(() => {
            return props.file.isEncoded;
        });
        const isError = computed(() => {
            if (!props.file.processingStartedAt)
                return false;
            const now = new Date();
            const processingStartedAt = new Date(props.file.processingStartedAt);
            const diffTime = Math.abs(now.getTime() - processingStartedAt.getTime());
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            return (props.file.isEncoded == false &&
                (diffDays >= 1 || props.file.encodingInProgress == false));
        });
        const onChangeOption = e => {
            hoverDropdown.value = false;
            switch (e) {
                case 'copy':
                    props.file.isPrivate
                        ? copyPrivateUrl(props.file)
                        : copyToClipboard(props.file.url);
                    sendNotification({
                        title: t('common.copiedClipboard'),
                        type: 'success',
                    });
                    break;
                case 'move':
                    emitter.emit('moveItem', props.file);
                    break;
                case 'rename':
                    emitter.emit('renameObject', props.file);
                    break;
                case 'select':
                    selectItem(true);
                    break;
                case 'delete':
                    emitter.emit('deleteFileFolder', props.file);
                    break;
                case 'import':
                    importToMediaLibrary();
                    break;
                default:
                    break;
            }
        };
        const isProcessing = computed(() => {
            return props.file.isEncoded == false && props.file.encodingInProgress == true;
        });
        const showDownloadOption = computed(() => {
            return !state.mediaModal && (hover.value || hoverDropdown.value);
        });
        const getThumbnail = computed(() => {
            const { contentType, isPrivate, category, subCategory } = props.file;
            const isPrivateSystemFolder = PRIVATE_SYSTEM_FOLDER.includes(category) ||
                PRIVATE_SYSTEM_FOLDER.includes(`${category}_${subCategory}`);
            const privateMode = isPrivate || isPrivateSystemFolder;
            let icon;
            switch (true) {
                case contentType.startsWith('image') && privateMode:
                    icon = ImagePrivateIcon;
                    break;
                case MIME_TYPES['documents']['pdf'].includes(contentType):
                    icon = privateMode ? PdfPrivateIcon : PdfIcon;
                    break;
                case MIME_TYPES['documents']['excel'].includes(contentType):
                    icon = privateMode ? ExcelPrivateIcon : ExcelIcon;
                    break;
                case MIME_TYPES['documents']['doc'].includes(contentType):
                    icon = privateMode ? DocsPrivateIcon : DocsIcon;
                    break;
                case MIME_TYPES['documents']['ppt'].includes(contentType):
                    icon = privateMode ? PptPrivateIcon : PptIcon;
                    break;
                case MIME_TYPES['documents']['text'].includes(contentType):
                    icon = privateMode ? TextPrivateIcon : TextIcon;
                    break;
                case MIME_TYPES['audio'].includes(contentType):
                    icon = privateMode ? AudioPrivateIcon : AudioIcon;
                    break;
                case MIME_TYPES['video'].includes(contentType) &&
                    selfHosted.value &&
                    isEncoded.value:
                    icon = privateMode ? VideoEncodedPrivateIcon : VideoEncodedIcon;
                    break;
                case MIME_TYPES['video'].includes(contentType):
                    icon = privateMode ? VideoPrivateIcon : VideoIcon;
                    break;
                case MIME_TYPES['zip'].includes(contentType):
                    icon = privateMode ? ZipPrivateIcon : ZipIcon;
                    break;
                case MIME_TYPES['documents']['csv'].includes(contentType):
                    icon = privateMode ? CsvPrivateIcon : CsvIcon;
                    break;
                case contentType === 'font/ttf':
                    icon = isPrivate ? TtfPrivateIcon : TtfIcon;
                    break;
                case contentType === 'font/otf':
                    icon = isPrivate ? OtfPrivateIcon : OtfIcon;
                    break;
                case contentType === 'font/woff' || contentType === 'application/font-woff':
                    icon = isPrivate ? WoffPrivateIcon : WoffIcon;
                    break;
                case contentType === 'font/woff2':
                    icon = isPrivate ? Woff2PrivateIcon : Woff2Icon;
                    break;
                default:
                    icon = ''; // fallback for unsupported file types
                    break;
            }
            return icon;
        });
        const toggleDropdown = e => {
            hoverDropdown.value = !hoverDropdown.value;
            e.stopPropagation();
        };
        const downloadMediaFile = () => __awaiter(this, void 0, void 0, function* () {
            try {
                sendNotification({
                    title: t('common.downloadInProgress'),
                    type: 'success',
                });
                let fileUrl = props.file.url;
                // For private files first get the signed url and then download with that url
                if (props.file.isPrivate) {
                    const { data: { url }, } = yield MediaServices.getSignedUrl({
                        altId: props.file.altId,
                        fileId: props.file._id,
                        contentType: props.file.contentType,
                        mode: PRIVATE,
                    });
                    fileUrl = url;
                }
                const params = {
                    name: props.file.name,
                    fileUrl,
                    openFileInNewTab: props.file.contentType.startsWith('image'),
                };
                if (state.activeCategory.includes(GOOGLE_DRIVE)) {
                    params.fileUrl = getDownloadUrl(props.file);
                    params.openFileInNewTab = false;
                    params.accessToken = state.activeGoogleConnection.token;
                }
                const isDownloaded = yield downloadFile(params);
                if (!isDownloaded)
                    sendNotification({
                        title: t('common.downloadFailed'),
                        type: 'error',
                    });
            }
            catch (error) {
                sendNotification({
                    title: t('common.downloadFailed'),
                    type: 'error',
                });
            }
        });
        const selectItem = checked => {
            if (checked) {
                state.setSelectedItems([
                    ...state.selectedItems,
                    {
                        _id: props.file._id,
                        altId: props.file.altId,
                        altType: props.file.altType,
                        parentId: props.file.parentId,
                        name: props.file.name,
                        url: props.file.url,
                        size: props.file.size,
                        contentType: props.file.contentType,
                        isPrivate: props.file.isPrivate,
                        category: props.file.category,
                    },
                ]);
            }
            else {
                const items = state.selectedItems.filter(selectedItem => selectedItem._id !== props.file._id);
                state.setSelectedItems(items);
            }
        };
        const dropdownOutsideClick = event => {
            var _a;
            if (dropdownOutsideClickRef.value &&
                !((_a = dropdownOutsideClickRef.value) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                hoverDropdown.value = false;
            }
        };
        const importToMediaLibrary = () => __awaiter(this, void 0, void 0, function* () {
            const params = {
                altId: state.altId,
                altType: state.altType,
                url: getDownloadUrl(props.file),
            };
            if (state.activeCategory.includes(GOOGLE_DRIVE)) {
                params.source = GOOGLE_DRIVE;
                params.extraParams = {
                    id: `drive-storage/${props.file._id}`,
                    name: props.file.name,
                    mimetype: props.file.contentType,
                    fileExtension: getFileExtension(props.file.contentType),
                    mode: state.mode,
                    oAuthConnectionId: state.activeGoogleConnection.id,
                };
            }
            sendNotification({
                title: t('common.importingFiles'),
                type: 'success',
            });
            try {
                yield MediaServices.addFile(params);
                sendNotification({
                    title: t('common.successfullyAdded'),
                    type: 'success',
                });
            }
            catch (error) {
                sendNotification({
                    title: t('common.failedToAddMedia'),
                    type: 'error',
                });
            }
        });
        onBeforeMount(() => {
            document.addEventListener('click', dropdownOutsideClick);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('click', dropdownOutsideClick);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["relative overflow-hidden bg-white shadow-xs rounded-lg group aspect-square h-full", {
                        'hover-effect': hover.value,
                        'border-blue-400 border-2 rounded-lg p-0.5': isSelected.value,
                        'ring-1 ring-black ring-opacity-5': !isSelected.value,
                        'opacity-50': _unref(state).isDragStarted && isSelected.value,
                    }]),
                onMouseenter: _cache[5] || (_cache[5] = ($event) => (hover.value = true)),
                onMouseleave: _cache[6] || (_cache[6] = ($event) => (hover.value = false))
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["relative overflow-hidden h-100 rounded-lg", {
                            'bg-gray-100': _ctx.disabled,
                            'bg-gray-50': !_ctx.disabled,
                        }])
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["rounded-lg w-full h-full overflow-hidden bg-gray-200", {
                                'opacity-40': _ctx.disabled,
                            }])
                    }, [
                        (_ctx.file.contentType.startsWith('image') &&
                            !_ctx.file.isPrivate &&
                            !_unref(PRIVATE_SYSTEM_FOLDER).includes(_ctx.file.category) &&
                            !_unref(PRIVATE_SYSTEM_FOLDER).includes(`${_ctx.file.category}_${_ctx.file.subCategory}`))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: getImageServerUrl(_ctx.file.url),
                                alt: "",
                                class: "object-cover rounded-lg w-full h-full"
                            }, null, 8 /* PROPS */, _hoisted_1))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: getThumbnail.value,
                                alt: "!",
                                class: "absolute inset-0 w-14 h-14 m-auto"
                            }, null, 8 /* PROPS */, _hoisted_2))
                    ], 2 /* CLASS */),
                    _createElementVNode("div", _hoisted_3, [
                        (_unref(state).selectedItems.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_unref(UICheckbox), {
                                    id: "select-checkbox",
                                    type: "default",
                                    checked: isSelected.value,
                                    "onUpdate:checked": selectItem
                                }, null, 8 /* PROPS */, ["checked"])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", {
                            onMouseenter: _cache[0] || (_cache[0] = ($event) => (statusHover.value = true)),
                            onMouseleave: _cache[1] || (_cache[1] = ($event) => (statusHover.value = false))
                        }, [
                            (selfHosted.value && !statusHover.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (isError.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _unref(FailedIcon),
                                            class: "w-5 h-5"
                                        }, null, 8 /* PROPS */, _hoisted_6))
                                        : (isProcessing.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: _unref(ProcessingIcon),
                                                class: "w-5 h-5"
                                            }, null, 8 /* PROPS */, _hoisted_7))
                                            : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true),
                            (selfHosted.value && statusHover.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (isError.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _unref(FailedWithTextIcon),
                                            class: "failed-hover-animation"
                                        }, null, 8 /* PROPS */, _hoisted_9))
                                        : (isProcessing.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: _unref(ProcessingWithTextIcon),
                                                class: "processing-hover-animation"
                                            }, null, 8 /* PROPS */, _hoisted_10))
                                            : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ], 32 /* NEED_HYDRATION */)
                    ]),
                    ((hover.value || hoverDropdown.value) && !isSelected.value && !_unref(state).isDragStarted)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "flex right-2 top-2 absolute image-hover-media z-[9]",
                            ref_key: "dropdownOutsideClickRef",
                            ref: dropdownOutsideClickRef
                        }, [
                            (showDownloadOption.value)
                                ? (_openBlock(), _createBlock(_unref(UIButton), {
                                    key: 0,
                                    id: "media-file-download",
                                    type: "default",
                                    size: "small",
                                    disabled: false,
                                    loading: false,
                                    ghost: false,
                                    quaternary: true,
                                    circle: false,
                                    text: false,
                                    onClick: downloadMediaFile
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Download01Icon), { class: "w-5 h-5 text-black cursor-pointer" })
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true),
                            _createVNode(_unref(UIDropdown), {
                                options: contextMenuItems.value,
                                id: "media-file-dropdown-menu",
                                placement: "bottom",
                                onClickoutside: _cache[2] || (_cache[2] = ($event) => (hoverDropdown.value = false)),
                                show: hoverDropdown.value,
                                onSelect: onChangeOption
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "media-file-dropdown",
                                        type: "default",
                                        size: "small",
                                        disabled: false,
                                        loading: false,
                                        ghost: false,
                                        quaternary: true,
                                        circle: false,
                                        text: false,
                                        onClick: toggleDropdown
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(DotsVerticalIcon), { class: "w-5 h-5 text-black cursor-pointer" })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["options", "show"])
                        ], 512 /* NEED_PATCH */))
                        : _createCommentVNode("v-if", true),
                    (!hover.value && !hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([
                                !isSelected.value ? 'media-file-name' : 'selected-file-gradient',
                                'h-full w-full inset-0 absolute',
                            ])
                        }, null, 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    (!hover.value && !hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_unref(UITooltip), null, {
                                trigger: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(truncate)(_ctx.file.name)), 1 /* TEXT */)
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: _normalizeClass([
                                isSelected.value ? 'selected-file-gradient' : 'media-gradient',
                                'h-full w-full inset-0 absolute rounded-lg',
                            ]),
                            onClick: _cache[3] || (_cache[3] = ($event) => (emit('onClickImage')))
                        }, null, 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            class: "image-hover-media text-white absolute bottom-2 left-2 w-full",
                            onClick: _cache[4] || (_cache[4] = ($event) => (emit('onClickImage')))
                        }, [
                            _createVNode(_unref(UITooltip), null, {
                                trigger: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(truncate)(_ctx.file.name)), 1 /* TEXT */)
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_unref(UITextXsRegular), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(timeFromNow(_ctx.file.updatedAt)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_unref(UITextXsRegular), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(formatBytes)(_ctx.file.size)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ], 34 /* CLASS, NEED_HYDRATION */));
        };
    }
});
